// Details the export didn't give: the country (asked once at upload) and the optional
// "Add details" answers (T05). Answers fill in what the
// export didn't say. Anything left blank stays unknown, never guessed, and the
// report says which checks that affected.

import type { CanonicalRota, Employee, Nation, Site } from '../model/types';

export type SiteDetails = Partial<Pick<Site, 'sector' | 'agreedNightPeriod' | 'weeklyRestScheme'>>;
export type EmployeeDetails = Partial<
  Pick<
    Employee,
    | 'dateOfBirth'
    | 'isUnder18'
    | 'optedOut48h'
    | 'isNightWorker'
    | 'setsOwnHours'
    | 'youngWorkerContractAfter22'
    | 'employmentStartDate'
  >
>;

export interface Details {
  /** The country the business is in, chosen once at upload and applied to every site. */
  nation?: Nation;
  sites: Record<string, SiteDetails>;
  employees: Record<string, EmployeeDetails>;
}

export const NO_DETAILS: Details = { sites: {}, employees: {} };

/** Returns a new rota with the answers applied. Undefined answers leave the imported value alone. */
export function applyDetails(rota: CanonicalRota, details: Details): CanonicalRota {
  return {
    ...rota,
    // The country is asked once, at upload, and applies to every site.
    sites: rota.sites.map((site) => ({
      ...site,
      ...(details.nation !== undefined && { nation: details.nation }),
      ...defined(details.sites[site.ref]),
    })),
    employees: rota.employees.map((e) => ({ ...e, ...defined(details.employees[e.ref]) })),
  };
}

function defined<T extends object>(values: T | undefined): Partial<T> {
  if (!values) return {};
  return Object.fromEntries(
    Object.entries(values).filter(([, v]) => v !== undefined && v !== ''),
  ) as Partial<T>;
}
